import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import qs from 'qs';

import { useOnboardUser } from 'lane-shared/hooks/onboarding/useOnboardUser';
import { usePublicProfileChannel } from 'lane-shared/hooks/onboarding/usePublicProfileChannel';
import routes from 'lane-shared/config/routes';
import { useUserDataContext } from 'lane-shared/hooks';
import { AppContext } from 'lane-shared/contexts';
import { useWorkplaceOnboardingEnabled } from 'lane-shared/hooks/onboarding/useWorkplaceOnboardingEnabled';

import {
  Onboarding,
  UserOnboardingData,
} from '../../components/onboarding/Onboarding';
import { isChannelFiltersError, isUnverifiedEmailError } from './utils';

const TRANSLATION_KEYS = {
  serverError: 'shared.onboarding.onboard.error',
  verifyEmailError: 'shared.onboarding.onboard.verifyEmail.error',
  channelFiltersError: 'shared.onboarding.signUp.channelFiltersError',
};

export const OnboardingPage = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const { transition } = useContext(AppContext);
  const { user, refetch: refetchUser } = useUserDataContext();
  const publicProfileData = usePublicProfileChannel();
  const { onboardUser } = useOnboardUser(user?._id, publicProfileData);
  const isWorkplaceOnboardingEnabled = useWorkplaceOnboardingEnabled();

  const handleOnOnboarding = async (data: UserOnboardingData) => {
    await onboardUser(data);
    await refetchUser();

    transition();

    const query = qs.parse(history?.location?.search.substring(1));
    const path = `${query.contentPath ? query.contentPath : routes.home}`;

    if (isWorkplaceOnboardingEnabled) {
      history.replace(path);
    } else {
      history.push(path);
    }
  };

  const handleOnboardingError = async (error: Error) => {
    if (isUnverifiedEmailError(error)) {
      return t(TRANSLATION_KEYS.verifyEmailError);
    }

    if (isChannelFiltersError(error)) {
      return t(TRANSLATION_KEYS.channelFiltersError);
    }

    return t(TRANSLATION_KEYS.serverError);
  };

  return (
    <Onboarding
      onOnboarding={handleOnOnboarding}
      onOnboardingError={handleOnboardingError}
    />
  );
};
